<div class="space-y-2">
    <div *ngFor="let plan of products" class="rounded-lg px-3 py-2 border border-gray-200 bg-white">
        <div class="plan-row">
            <span class="plan-name">{{ plan.productName | titlecase }}</span>
            <div class="plan-price">
                <span *ngIf="planRate(plan) > planRateWithDiscount(plan)" class="plan-price__was">
                    {{ planRate(plan) | currency }}
                </span>
                <span class="plan-price__now">{{ planRateWithDiscount(plan) | currency }}</span>
                <span class="plan-price__freq">{{ paymentFrequencyName() }}</span>
            </div>
        </div>
    </div>

    <div class="plans-total">
        <span class="plans-total__label">
            Total
            <span *ngIf="discount > 0" class="plans-total__discount">{{ discount / 100 | percent }} off</span>
        </span>
        <span class="plans-total__amount">{{ totalPriceWithDiscount() | currency }}
            <span class="plans-total__freq">{{ paymentFrequencyName() }}</span>
        </span>
    </div>
</div>
